import { useField, useFormikContext } from 'formik';
import RadioGroupControl, { type RadioOption } from './radio-group-control';

type Props = {
  name: string;
  options: RadioOption[];
  [key: string]: unknown;
};

const RadioGroupField = ({ name, options, ...controlProps }: Props) => {
  const [field] = useField(name);
  const formik = useFormikContext();

  return (
    <div>
      <RadioGroupControl
        name={name}
        options={options}
        form={formik}
        {...controlProps}
        {...field}
      />
    </div>
  );
};

export default RadioGroupField;
